export default __webpack_public_path__ + "static/gray-logo-copart-b584c35ffdb74f4f63e00193d15f89d5.png";